import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-curriculum-enhancement',
  templateUrl: './curriculum-enhancement.component.html',
  styleUrls: ['./curriculum-enhancement.component.scss']
})
export class CurriculumEnhancementComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;


  ngOnInit() {
    this.Form = this.formBuilder.group({
      overview: ['', Validators.required],
      _id: [''],
    });
// console.log(this.api_endpoint);
    this.http.get<any>(this.api_endpoint+'/curriculumEnhancementfindone/').subscribe(
        data => {
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              overview: data.data.overview,
              _id: data.data._id,
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  get f() { return this.Form.controls; }

  onFormSubmit(action){

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "overview" : this.Form.value.overview,
        "admin" : sessionStorage.getItem('adminName'),
        "_id" : this.Form.value._id,
      };
      this.http.put<any>(this.api_endpoint+'/curriculumEnhancement', data).subscribe(
        res => {
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            window.scrollTo(document.documentElement.clientWidth, 0);
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
            window.location.reload();
          } 
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else{
      
      var data1 = {
        "overview" : this.Form.value.overview,
        "admin" : sessionStorage.getItem('adminName'),
      };
      this.http.post<any>(this.api_endpoint+'/curriculumEnhancement', data1).subscribe(
        res => {
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            window.scrollTo(document.documentElement.clientWidth, 0);
            return
          }else{
            this.message = 'Successfully Submitted';
            this.class = 'btn btn-success';
            window.location.reload();
          } 
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
